import { render } from "./DataTableLoader.vue?vue&type=template&id=9f8de534&scoped=true"
import script from "./DataTableLoader.vue?vue&type=script&lang=js"
export * from "./DataTableLoader.vue?vue&type=script&lang=js"

import "./DataTableLoader.vue?vue&type=style&index=0&id=9f8de534&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.23_vue@3.5.23_typescript@5.4.2__webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f8de534"]])

export default __exports__